export default "__VITE_ASSET__BC$4ldUQ__"